import RequestBlock from './RequestBlock.jsx';
import SecurityContextBlock from './SecurityContextBlock.jsx';
import ApproverStatusBlock from './ApproverStatusBlock.jsx';
import { DetailSections } from '../shared/index.js';
import { useEventDraft } from '../../../context/useEventDraft.js';

/**
 * Break Glass detail body: request, security context, and the live two-key gate
 * (shared with the decision footer via EventDraft).
 */
function BreakGlassBody({ event }) {
  const detail = event.detail ?? {};
  const { breakGlassApprovers } = useEventDraft();
  const approvers = breakGlassApprovers ?? detail.approvers ?? [];
  const requiredCount = detail.requiredCount ?? 2;
  const confirmedCount = approvers.filter((a) => a.status === 'confirmed').length;
  const granted = confirmedCount >= requiredCount;

  const sections = [
    <RequestBlock key="request" detail={detail} />,
    detail.security ? <SecurityContextBlock key="security" security={detail.security} /> : null,
    approvers.length > 0 ? (
      <ApproverStatusBlock
        key="approvers"
        approvers={approvers}
        confirmedCount={confirmedCount}
        requiredCount={requiredCount}
        granted={granted}
      />
    ) : null,
  ].filter(Boolean);

  return <DetailSections sections={sections} />;
}

export default BreakGlassBody;
